module.exports = __webpack_public_path__ + "img/cyan-phone.1cb60df2.svg";